module.exports = {
    tag: 'sky',
    quality: 0.6,
    learning: 2,
	perception: 2,
	speed: 0.2
};